import IconCrownSolid from '@/assets/icons/font_awesome/crown-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { toast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_transfer_ownership_proposal_delete } from '@/state/workspace/ownership/remote_workspace_transfer_ownership_proposal_delete';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { RequestWorkspaceUserOwnershipTransferDelete } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_delete';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useTranslation } from 'react-i18next';

interface Props {
  item: DTO__workspace_user;
}

export function WSButtonWorkspaceUserTransferOwnershipRevoke({ item }: Props) {
  const { t } = useTranslation([ENUM__i18n_namespace.BASE_UI, ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE]);

  const dispatch = use_dispatch();

  const { workspace_current, current_workspace_user, transfer_ownership_proposals_map } = use_slice_workspace([
    'workspace_current',
    'current_workspace_user',
    'transfer_ownership_proposals_map',
  ]);

  const transfer_ownership_proposal_workspace_current = Array.from(transfer_ownership_proposals_map.values()).find(
    item => item.workspace_id == workspace_current._id,
  );

  const tooltip_title = t(i18n_page_settings_workspace.tabs.users.shared.table.users.button.transfer_ownership_revoke.tooltip);

  async function onClick() {
    assert_not_null(transfer_ownership_proposal_workspace_current, {
      context: 'transfer_ownership_proposal_workspace_current',
      workspace_id: workspace_current._id,
    });

    let request = new RequestWorkspaceUserOwnershipTransferDelete();
    request.workspace_id = transfer_ownership_proposal_workspace_current.workspace_id;
    request.proposal_id = transfer_ownership_proposal_workspace_current._id;

    await dispatch(remote_workspace_transfer_ownership_proposal_delete(request));

    toast({ title: t(i18n_base_ui.toasts.transfer_ownership_revoke.title) });
  }

  //do not show for not owners
  if (workspace_current.user_id_owner != current_workspace_user.user_id) return null;

  //can't revoke transfer ownership
  if (!transfer_ownership_proposal_workspace_current) return null;

  //can't revoke transfer ownership to self
  if (transfer_ownership_proposal_workspace_current.target_user_id != item.user_id) return null;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        iconClassNameBase="!w-5 !h-5"
        iconClassNameHovered={` !text-red-400`}
        iconClassNameNonHovered={` !text-red-700`}
        Icon={IconCrownSolid}
        {...{ onClick }}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
